import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Button from './Button';

const InputSecured = ({
  apikey,
  copied,
  handleChange,
  handleCopy,
  handleShowText,
  readOnly,
  showText,
  value,
}) => {
  return (
    <div>
      <div className="input-show-data-group">
        <div className="input-show-data-subgroup">
          <Button
            type="button"
            icon={
              showText ? (
                <i className="fas fa-eye-slash fa-lg" />
              ) : (
                <i className="fas fa-eye fa-lg" />
              )
            }
            onClick={handleShowText}
            showText
          />
          <input
            type={showText ? 'text' : 'password'}
            value={value}
            onChange={readOnly ? null : handleChange}
            readOnly={readOnly}
            className="input-show-data-text"
          />
        </div>
        {apikey && (
          <CopyToClipboard text={value} onCopy={handleCopy}>
            <Button label="Copier" light copy />
          </CopyToClipboard>
        )}
      </div>
      {copied ? <span className="input-button-copy-info">Copié !</span> : null}
    </div>
  );
};

export default InputSecured;
